import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export type BtnMode = 'base' | 'free_spins' | 'autoplay';

export const spinButtonStore = Store.createStore({
    spinBtn_btnMode: Store.signal<BtnMode>('base'),

    spinBtn_isAutoPlayActivated: Store.signal(false),
    spinBtn_isFsActivated: Store.signal(false),

    spinBtn_fsCurrent: Store.signal(0),
    spinBtn_fsTotal: Store.signal(0),

    spinBtn_btnDisabled: Store.signal(false),
    spinBtn_btnSkipEnabled: Store.signal(false),
    spinBtn_btnQuickStopEnabled: Store.signal(false),
});